import { render, staticRenderFns } from "./entregaresultados.vue?vue&type=template&id=651f6e69"
import script from "./entregaresultados.vue?vue&type=script&lang=js"
export * from "./entregaresultados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports